"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VISITOR_SEGMENT = exports.USE_PRODUCT_DATA_CACHING = exports.USE_PRODUCTS_SERVICE = exports.TENANT_CONTEXT = exports.REGISTRATION_ID = exports.PREVIEW_MODE = exports.PLACEMENT = exports.CUSTOMER_TYPE_ID = exports.CUSTOMER_CONTEXT = exports.CONTENT_TYPE = exports.CLIENT_APPLICATION = exports.CHANNEL_TYPE = exports.AUTHORIZATION = exports.ATP_CLUSTER_ID = exports.ACCEPT_LANGUAGE = void 0;
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'accept-language';
const ATP_CLUSTER_ID = exports.ATP_CLUSTER_ID = 'x-atp-cluster-id';
const AUTHORIZATION = exports.AUTHORIZATION = 'authorization';
const CHANNEL_TYPE = exports.CHANNEL_TYPE = 'x-client-channel';
const CLIENT_APPLICATION = exports.CLIENT_APPLICATION = 'x-client-application';
const CONTENT_TYPE = exports.CONTENT_TYPE = 'content-type';
const CUSTOMER_CONTEXT = exports.CUSTOMER_CONTEXT = 'x-customer-context';
const CUSTOMER_TYPE_ID = exports.CUSTOMER_TYPE_ID = 'x-customer-type-id';
const PLACEMENT = exports.PLACEMENT = 'x-placement';
const PREVIEW_MODE = exports.PREVIEW_MODE = 'x-preview-mode';
const REGISTRATION_ID = exports.REGISTRATION_ID = 'x-registration-id';
const TENANT_CONTEXT = exports.TENANT_CONTEXT = 'x-tenant-context';
const USE_PRODUCT_DATA_CACHING = exports.USE_PRODUCT_DATA_CACHING = 'x-use-product-data-caching';
const USE_PRODUCTS_SERVICE = exports.USE_PRODUCTS_SERVICE = 'x-use-products-service';
const VISITOR_SEGMENT = exports.VISITOR_SEGMENT = 'x-visitor-segment';
